// Strings are display names for SystemRequirements tabs.
export enum OperatingSystemNames {
    ANDROID = 'Android',
    IOS = 'iOS',
    MAC = 'Mac',
    WINDOWS = 'Windows',
    WIN32 = 'Win32', // shows as 'Windows' in tabs
    LINUX = 'Linux'
}

// TODO: Needs to be reconciled with the above. referenced by legacy system requirements & current.
export enum OS_NAME {
    ANDROID = 'Android',
    IOS = 'iOS',
    MAC = 'Mac',
    WINDOWS = 'Windows',
    WIN32 = 'Win32', // shows as 'Windows' in tabs
    LINUX = 'Linux'
}

// Regex string used for root.navigator.appVersion
export const navigators = {
    [OperatingSystemNames.ANDROID]: 'Android',
    [OperatingSystemNames.IOS]: 'iP',
    [OperatingSystemNames.MAC]: 'Mac',
    [OperatingSystemNames.WINDOWS]: 'Win',
    [OperatingSystemNames.LINUX]: 'Linux'
};

export default {
    name: OperatingSystemNames,
    navigators,
    OS_NAME
};
